import { render } from "./KeyButton.vue?vue&type=template&id=664ecef0&scoped=true"
import script from "./KeyButton.vue?vue&type=script&lang=js"
export * from "./KeyButton.vue?vue&type=script&lang=js"

import "./KeyButton.vue?vue&type=style&index=0&id=664ecef0&scoped=true&lang=css"

import exportComponent from "F:\\Programming_And_Stuff\\Programming\\VueJs\\hangman\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-664ecef0"]])

export default __exports__